import { useContext, useEffect } from "react";

import { handelTitle } from '../../utils'

import Breadcrumb from "../../components/Breadcrumb";
import { toast } from "react-toastify"
import SecHeader from './Header'
import SecForm from './Form'
import { useNavigate, useLocation } from "@tanstack/react-router";
import { useAppKit } from '@reown/appkit/react'
import { AppContext } from "../../App.jsx";
import { useAuth } from "../../lib/auth";
import { parseSessionToken } from "../../lib/window-shim";

/**
 * Sign In page container.
 *
 * Handles user authentication and login.
 * Features:
 * - Displays sign-in form (SecForm)
 * - Auto-redirects to home if already authenticated
 * - Sets global app state on successful login
 * - Supports signout route (/signout)
 * - Uses Reown AppKit for wallet-based authentication
 *
 * @module containers/SignIn
 * @category Containers
 * @returns {React.ReactElement} Rendered sign-in page or null if logging out
 */
const SignInContainer = () => {
    const _ac = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { login, logout } = useAuth();

    // Handle signout route
    if (location.pathname === "/signout") {
        logout();
        navigate({ to: "/signin" });
        return null;
    }

    // Check authentication on mount and set global state if applicable
    useEffect(() => {
        const token = parseSessionToken();
        if (token) {
            try {
                if (token?.auth === true) {
                    _ac?.state?.sPI(token);
                    login(token);
                    navigate({ to: "/profile" });
                }
            } catch (e) {
                console.error("Failed to parse token", e);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        handelTitle('Sign In');
    }, []);

    const callback = (vars_set) => {
        try {
            const userToken = JSON.parse(vars_set);
            // Use AuthProvider login to sync both sessionStorage and context state
            login(userToken);
            // Preserve existing behavior: set global app state
            _ac?.state?.sPI(userToken);
            navigate({ to: "/profile" });
        } catch (e) {
            toast("Error in form input");
            toast(e.message);
        }
    };

    return (
        <>
            <Breadcrumb text1="Home" text2="Sign In"/>
            <section className="h-100-vh mb-4">
                {/*<SecHeader />*/}
                <div className="container">
                    <div className="mt-10">
                        <SecForm callback={callback} />
                    </div>
                </div>
            </section>
        </>
    );
};

export default SignInContainer;